import { useEffect, useState } from "react";
import { FileDown, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl, formatIDR } from "@/lib/api";
import { exportSettlementPdf } from "@/lib/settlementPdf";

export const SettlementDetail = ({ withdrawalId, onClose }) => {
  const [rec, setRec] = useState(null);

  useEffect(() => {
    if (!withdrawalId) return;
    setRec(null);
    api.get(`/wallet/withdrawals/${withdrawalId}`)
      .then((r) => setRec(r.data))
      .catch(() => { toast.error("Gagal memuat rincian settlement"); onClose(); });
  }, [withdrawalId, onClose]);

  if (!withdrawalId) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose} data-testid="settlement-modal">
      <div className="bg-white w-full sm:max-w-lg rounded-t-3xl sm:rounded-3xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <div>
            <div className="font-bold text-gray-900">Rincian Settlement</div>
            <div className="text-xs text-gray-400" data-testid="settlement-mch-no">{rec?.mch_order_no || "..."}</div>
          </div>
          <button data-testid="settlement-close" onClick={onClose} className="p-2 rounded-full hover:bg-gray-100"><X className="w-5 h-5" /></button>
        </div>
        {!rec ? (
          <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#0B4DA2]" /></div>
        ) : (
          <SettlementBody rec={rec} />
        )}
      </div>
    </div>
  );
};

const SettlementBody = ({ rec }) => (
  <>
    <div className="p-5 overflow-y-auto space-y-3">
      <div className="grid grid-cols-2 gap-2 text-xs">
        <Info label="Seller" value={rec.seller_name} />
        <Info label="Status" value={rec.status} testid="settlement-status" />
        <Info label="Rekening" value={`${rec.bank_name || "-"} ${rec.account_no || ""}`} />
        <Info label="Tanggal" value={new Date(rec.created_at).toLocaleString("id-ID")} />
      </div>
      <div className="text-sm font-semibold text-gray-800 pt-2">Produk yang dicairkan ({rec.orders.length})</div>
      {rec.orders.length === 0 && <div className="text-xs text-gray-400">Penarikan lama — tidak ada rincian produk tercatat.</div>}
      {rec.orders.map((o) => (
        <div key={o.id} data-testid={`settlement-order-${o.id}`} className="flex items-center gap-3 p-2.5 rounded-xl border border-gray-100">
          <img src={fileUrl(o.product_image)} alt="" className="w-11 h-11 rounded-lg object-cover bg-gray-100" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium line-clamp-1">{o.product_title}</div>
            <div className="text-[11px] text-gray-400">{o.buyer_name} • {o.paid_at ? new Date(o.paid_at).toLocaleDateString("id-ID") : "-"}</div>
          </div>
          <div className="text-sm font-bold text-[#0B4DA2]">{formatIDR(o.price)}</div>
        </div>
      ))}
    </div>
    <div className="p-5 border-t border-gray-100 flex items-center justify-between gap-3">
      <div>
        <div className="text-[11px] text-gray-400">Total dicairkan</div>
        <div className="font-extrabold text-lg" data-testid="settlement-total">{formatIDR(rec.amount)}</div>
      </div>
      <button data-testid="settlement-export-pdf" onClick={() => exportSettlementPdf(rec)} className="flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-[#0B4DA2] text-white text-sm font-semibold hover:bg-[#093d82] transition-colors">
        <FileDown className="w-4 h-4" /> Export PDF
      </button>
    </div>
  </>
);

const Info = ({ label, value, testid }) => (
  <div className="p-2.5 rounded-xl bg-gray-50">
    <div className="text-gray-400">{label}</div>
    <div className="font-semibold text-gray-800 line-clamp-1" data-testid={testid}>{value || "-"}</div>
  </div>
);
